import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const FloatingCta = () => {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3 pointer-events-auto">
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919150299336?text=Hi%20Nawabi%20Caterers,%20I%20would%20like%20to%20discuss%20catering%20for%20my%20event."
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2.5 px-4 py-3 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-105 hover:bg-[#20ba59] transition-all duration-300 font-medium text-xs tracking-wider uppercase border border-white/30"
        title="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-5 h-5" />
        <span className="hidden sm:inline">WhatsApp Us</span>
      </a>

      {/* Phone Call Floating Button */}
      <a
        href="tel:+919150299336"
        className="flex items-center gap-2.5 px-4 py-3 rounded-full bg-[#0a1a0f] text-[#E8A040] shadow-2xl hover:scale-105 hover:bg-[#132c1c] transition-all duration-300 font-medium text-xs tracking-wider uppercase border border-[#E8A040]/40"
        title="Call Nawabi Caterers"
      >
        <FaPhoneAlt className="w-4 h-4" />
        <span className="hidden sm:inline">+91 91502 99336</span>
      </a>
    </div>
  );
};

export default FloatingCta;

